<template>
  <solid-box
    :title="moduleName"
  >
      <div
          class="list"
      >
          <div class="item">
              <div class="body all-center">
                  <img src="../../../assets/images/nongye_1.png" alt="" />
              </div>
              <p>
                完成建设面积（亩）
              </p>
              <div class="footer">
                  {{ farmlandSummary.finishArea }}
              </div>
          </div>
          <div class="item">
              <div class="body all-center">
                  <img src="../../../assets/images/nongye_2.png" alt="" />
              </div>
              <p>
                正在建设面积（亩）
              </p>
              <div class="footer">
                  {{ farmlandSummary.implementationArea }}
              </div>
          </div>
      </div>
  </solid-box>
</template>

<script>
import SolidBox from '@/components/SolidBox'
import * as screenAPI from '@/api/screen'

/**
* 农业数据
*/
export default {
  props: {
      moduleName: {
          type: String,
          default: ''
      }
  },
  data() {
      return {
          farmlandSummary: {
            implementationArea: '0',
            finishArea: '0'
          }
      }
  },
  mounted() {
      this.getSummary()
      this.$eventHub.$on('areaChange', () => {
          this.getSummary()
      })
  },
  components: {
      SolidBox
  },
  methods: {
      async getSummary() {
          const params = {
              siteId: this.$route.params.id,
              locId: this.$getLocId()
          }
          const data = await screenAPI.queryFarmlandData(
              params
          ) // 农业数据
          this.farmlandSummary =
              data.data || this.farmlandSummary
      }
  }
}
</script>

<style lang="scss" scoped>
@keyframes lds-ring {
  0% {
      transform: rotate(135deg);
  }
  100% {
      transform: rotate(495deg);
  }
}

@keyframes lds-ring2 {
  0% {
      transform: rotate(45deg);
  }
  100% {
      transform: rotate(405deg);
  }
}

@keyframes lds-ring3 {
  0% {
      transform: rotate(225deg);
  }
  100% {
      transform: rotate(585deg);
  }
}

.list {
  display: flex;
  padding: 30px 30px 0;
  justify-content: space-around;

  > .item {
      > .body {
          width: 138px;
          height: 128px;
          position: relative;

          text-align: center;
          font-size: 24px;
          background-image: linear-gradient(
              90deg,
              rgba(18, 52, 81, 0.8) 4%,
              rgba(18, 52, 81, 0.5) 48%,
              rgba(18, 52, 81, 0.1) 96%
          );
          border-radius: 6.8px;
          img {
              height: 80px;
          }
      }

      > p {
          font-size: 13.6px;
          color: #0bf9d9;
          text-align: center;
          font-weight: bold;
          margin: 18px 0 14px;
      }

      > .footer {
          font-weight: bold;
          font-size: 21px;
          color: #ffffff;
          letter-spacing: 1.2px;
          text-align: center;
          line-height: 22px;
          word-break: break-all;
          max-width: 138px;
      }
  }
}
</style>
